import {
  CREATE_PROJECT,
  GET_ALL_PROJECTS,
  ARCHIVE_PROJECT,
  UPDATE_PROJECT,
  DELETE_PROJECT,
  GET_QUICKBOOKS_PROJECTS,
  GET_SAGE_INTACCT_DATA,
  TRANSFER_DIVISIONS,
  UPDATE_PROJECT_CUSTOMER,
  GET_PROJECT_SCHEDULE_OF_VALUES,
  UPDATE_PROJECT_SCHEDULE_OF_VALUES,
  SUBMIT_PROJECT_SCHEDULE_OF_VALUES,
  UPDATE_PROJECT_SCHEDULE_OF_VALUES_ROW,
  DELETE_PROJECT_SCHEDULE_OF_VALUES_ROW,
  SWAP_ROW_PROJECT_SCHEDULE_OF_VALUES,
  GET_PROJECT_SCHEDULE_OF_VALUES_PDF_ROWS,
  UPDATE_PROJECT_SCHEDULE_OF_VALUES_PDF_ROWS,
  ADD_PROJECT_SCHEDULE_OF_VALUES_PDF_ROWS,
  DELETE_PROJECT_SCHEDULE_OF_VALUES_PDF_ROWS,
  UPDATE_INDIVIDUAL_PROJECT,
  UPDATE_PROJECT_FROM_COST_TRACKING,
  GET_PROJECT_ATTACHMENTS,
  GET_ALL_PROJECT_COSTCODE_DETAILS,
  GET_SCHEDULE_OF_VALUE_TEMPLATES,
  CREATE_SCHEDULE_OF_VALUE_TEMPLATE,
  UPDATE_SCHEDULE_OF_VALUE_TEMPLATE,
  DELETE_SCHEDULE_OF_VALUE_TEMPLATE,
  APPLY_SCHEDULE_OF_VALUE_TEMPLATE,
  GET_PROJECT_FILE_TEMPLATES,
  ADD_PROJECT_FILE_TEMPLATE,
  UPDATE_PROJECT_FILE_TEMPLATE,
  DELETE_PROJECT_FILE_TEMPLATE,
  UPDATE_PROJECT_PROGRESS_FILTERS,
  GET_PROJECT_GROUPS,
  CREATE_PROJECT_GROUP,
  UPDATE_PROJECT_GROUP,
  DELETE_PROJECT_GROUP,
  GET_PROJECT_GROUP_NOTES,
  ADD_PROJECT_GROUP_NOTE,
  GET_PROJECT_TYPES,
  GET_QUICKBOOKS_CLASSES,
  GET_PROJECT_COST_UPDATES,
  GET_SCHEDULE_OF_VALUE_SECTIONS,
  CREATE_SCHEDULE_OF_VALUE_SECTION,
  UPDATE_SCHEDULE_OF_VALUE_SECTION,
  DELETE_SCHEDULE_OF_VALUE_SECTION,
  GET_PROGRESS_SUBCONTRACT_UPDATES,
  GET_SUB_CONTRACTS,
  UPDATE_PROGRESS_SUBCONTRACT,
  DELETE_PROGRESS_SUBCONTRACT_UPDATE,
  UPDATE_PROGRESS_SUBCONTRACT_ROW,
  GET_PROJECT_CUSTOM_FIELD_TEMPLATE,
  UPDATE_PROJECT_CUSTOM_FIELD_TEMPLATE,
  GET_PROJECT_CUSTOM_DATA,
  GET_PROJECT_NOTES,
  ADD_PROJECT_NOTE,
  GEOCODE_PROJECT,
  EDIT_PROJECT_SCHEDULE_OF_VALUES_PAST_BILL,
  GET_PROJECT_EQUIPMENT_BUCKET_OVERRIDE_TREE,
  GET_PROJECT_EQUIPMENT_TABLE_COLUMNS,
  UPDATE_PROJECT_EQUIPMENT_TABLE_COLUMNS,
  GET_PROJECT_LABELS,
  UPDATE_PROJECT_LABELS,
  GET_MY_PROJECT_TAGS,
  MARK_PROJECT_TAGS_AS_READ,
  NEW_PROJECT_TAGS_FROM_SOCKET,
  GET_MY_PROJECT_GROUP_TAGS,
  MARK_PROJECT_GROUP_TAGS_AS_READ,
  NEW_PROJECT_GROUP_TAGS_FROM_SOCKET,
  UPDATE_PROJECT_SUB_CONTRACT,
  SUBMIT_PROJECT_SCHEDULE_OF_VALUES_INVOICE_HOLDBACK,
  UPDATE_PROJECT_FILTERS,
  GET_USER_PROJECT_FILTER_VIEWS,
  CREATE_USER_PROJECT_FILTER_VIEW,
  UPDATE_USER_PROJECT_FILTER_VIEW,
  DELETE_USER_PROJECT_FILTER_VIEW,
  FAVOURITE_USER_PROJECT_FILTER_VIEW,
  SET_FILTERED_PROJECT_IDS,
  GET_PROJECT_CUSTOM_CATEGORY_ESTIMATES,
} from '../../state/actionTypes';

import sortByString from '../../helpers/helpers';
import { getLabelsState } from '../../helpers/labels';

const initialState = {
  projects: [],
  quickbooksProjects: [],
  sageIntacctProjects: [],
  scheduleOfValues: {},
  scheduleOfValuePDFRows: [],
  progressHistoryAttachments: [],
  project: {},
  projectCostcodeDetails: {},
  scheduleOfValueTemplates: [],
  newScheduleOfValueTemplate: {},
  projectFileTemplates: [],
  projectProgressFilters: {},
  projectGroups: [],
  projectGroupsNotes: {},
  projectTypes: [],
  quickbookClassMap: {},
  projectAttachments: {
    instantiatedFiles: [],
    locationMap: {},
  },
  projectCostUpdates: [],
  scheduleOfValueSections: [],
  subContracts: [],
  subContractUpdates: {},
  customFieldTemplate: {},
  customData: [],
  customDataFiles: {},
  notes: {},
  notesFileMap: {},
  projectEquipmentBucketOverrideTree: [],
  equipmentTableColumns: {},
  projectToLabel: {},
  labelToProject: {},
  myProjectTags: [],
  myReadProjectTags: [],
  projectTagsPerProject: {},
  myProjectGroupTags: [],
  myReadProjectGroupTags: [],
  projectGroupTagsPerProjectGroup: {},
  newEstimatedSubContractTotalValues: {},
  projectFilters: {},
  projectFilterViews: [],
  filteredProjectIds: null,
  customCategoryEstimates: {},
};

const createProjectTagCountMap = (tags = []) => {
  const tagPerProjectMap = {};
  tags.forEach((tag) => {
    const { projectId } = tag;
    const {
      [projectId]: oldCount = 0,
    } = tagPerProjectMap;
    tagPerProjectMap[projectId] = oldCount + 1;
  });
  return tagPerProjectMap;
};

const createProjectGroupTagCountMap = (tags = []) => {
  const tagPerProjectGroupMap = {};
  tags.forEach((tag) => {
    const { projectGroupId } = tag;
    const {
      [projectGroupId]: oldCount = 0,
    } = tagPerProjectGroupMap;
    tagPerProjectGroupMap[projectGroupId] = oldCount + 1;
  });
  return tagPerProjectGroupMap;
};

export default function projectActions(state = initialState, action) {
  switch (action.type) {
    case CREATE_PROJECT: {
      const {
        payload: {
          project = {},
        } = {},
      } = action;
      const {
        id: projectId,
      } = project;
      if (new Set(state.projects.map((p) => p.id)).has(projectId)) return state;
      const {
        assignToUser,
        ...projectRest
      } = project;
      return {
        ...state,
        projects: state.projects.concat([{
          ...projectRest,
          active: 1,
        }]).sort(sortByString('name')),
      };
    }
    case GET_ALL_PROJECTS:
      return {
        ...state,
        projects: action.payload.projects.sort(sortByString('name')),
      };
    case UPDATE_PROJECT: {
      const {
        projectId,
        data: {
          details,
        } = {},
      } = action.payload;
      return {
        ...state,
        projects: state.projects.map((project) => {
          if (project.id !== projectId) return project;
          return { ...project, ...details };
        }),
      };
    }
    case UPDATE_PROJECT_SUB_CONTRACT: {
      const {
        projectId,
        estimatedSubContractTotalValue,
      } = action.payload;
      return {
        ...state,
        newEstimatedSubContractTotalValues: {
          ...state.newEstimatedSubContractTotalValues,
          [projectId]: estimatedSubContractTotalValue,
        },
      };
    }
    case UPDATE_PROJECT_LABELS: {
      const {
        projectId,
        addedLabels = [],
        removedLabels = [],
      } = action.payload;

      const currentLabels = state.projectToLabel[projectId] || [];
      const newLabels = currentLabels
        .filter((labelId) => !removedLabels.includes(labelId))
        .concat(addedLabels.map((label) => label.labelId || label.id));

      return {
        ...state,
        projectToLabel: {
          ...state.projectToLabel,
          [projectId]: newLabels,
        },
      };
    }
    case UPDATE_INDIVIDUAL_PROJECT: {
      const {
        data = {},
      } = action.payload;
      return {
        ...state,
        project: {
          ...data,
        },
      };
    }
    case UPDATE_PROJECT_FROM_COST_TRACKING: {
      const {
        projectId,
        project: updatedProject,
        customCategoryEstimates: projectCustomEstimates,
      } = action.payload;
      const nextProject = (state.project?.id === projectId ? updatedProject : state.project);
      return {
        ...state,
        project: nextProject,
        projects: state.projects.map((p) => (p.id === projectId ? { ...p, ...updatedProject } : p)),
        customCategoryEstimates: {
          ...state.customCategoryEstimates,
          ...(projectCustomEstimates && projectId
            ? { [projectId]: projectCustomEstimates }
            : {}),
        },
      };
    }
    case GET_PROJECT_ATTACHMENTS: {
      const {
        payload: {
          projectAttachments = [],
        } = {},
      } = action;

      return {
        ...state,
        projectAttachments,
      };
    }
    case ARCHIVE_PROJECT: {
      const {
        payload: {
          projectId,
          active,
        },
      } = action;
      return {
        ...state,
        projects: state.projects.map((project) => {
          if (project.id !== projectId) return project;
          const newProject = { ...project };
          newProject.active = active ? 1 : 0;
          return newProject;
        }),
      };
    }
    case DELETE_PROJECT: {
      const {
        payload: {
          id,
        } = {},
      } = action;
      return {
        ...state,
        projects: state.projects.filter((project) => project.id !== id),
      };
    }
    case GET_QUICKBOOKS_PROJECTS: {
      const {
        data: quickBooksProjects,
      } = action.payload;
      return {
        ...state,
        quickBooksProjects,
      };
    }
    case GET_SAGE_INTACCT_DATA: {
      const {
        data: {
          projects: sageIntacctProjects = [],
        } = {},
      } = action.payload;
      return {
        ...state,
        sageIntacctProjects,
      };
    }
    case TRANSFER_DIVISIONS: {
      const {
        payload: { type, divisionId, ids = [] },
      } = action;
      const {
        projects: stateProjects = [],
      } = state;
      if (type !== 'projects') return state;
      const idSet = new Set(ids);
      return {
        ...state,
        projects: stateProjects.map((project) => {
          if (!idSet.has(project.id)) return project;
          return {
            ...project,
            divisionId,
          };
        }),
      };
    }
    case UPDATE_PROJECT_CUSTOMER: {
      const {
        payload: { customerId, projectIds = [] },
      } = action;
      const {
        projects: stateProjects = [],
      } = state;
      const idSet = new Set(projectIds);
      return {
        ...state,
        projects: stateProjects.map((project) => {
          if (!idSet.has(project.id)) return project;
          return {
            ...project,
            customerId,
          };
        }),
      };
    }
    case GET_PROJECT_SCHEDULE_OF_VALUES:
    case UPDATE_PROJECT_SCHEDULE_OF_VALUES:
    case DELETE_PROJECT_SCHEDULE_OF_VALUES_ROW:
    case SUBMIT_PROJECT_SCHEDULE_OF_VALUES:
    case SWAP_ROW_PROJECT_SCHEDULE_OF_VALUES:
    case EDIT_PROJECT_SCHEDULE_OF_VALUES_PAST_BILL:
    case SUBMIT_PROJECT_SCHEDULE_OF_VALUES_INVOICE_HOLDBACK:
      return {
        ...state,
        scheduleOfValues: action.payload.scheduleOfValues || [],
      };
    case APPLY_SCHEDULE_OF_VALUE_TEMPLATE:
      return {
        ...state,
        scheduleOfValues: action.payload.scheduleOfValues,
        scheduleOfValueSections: action.payload.sections,
      };
    case UPDATE_PROJECT_SCHEDULE_OF_VALUES_ROW: {
      const {
        scheduleOfValues: {
          [action.payload.key]: rowHistory,
        },
      } = state;

      if (rowHistory) {
        rowHistory.push(action.payload.value);
        return {
          ...state,
          scheduleOfValues: {
            ...state.scheduleOfValues,
            [action.payload.key]: rowHistory,
          },
        };
      }

      return {
        ...state,
      };
    }
    case GET_PROJECT_SCHEDULE_OF_VALUES_PDF_ROWS:
    case UPDATE_PROJECT_SCHEDULE_OF_VALUES_PDF_ROWS:
    case ADD_PROJECT_SCHEDULE_OF_VALUES_PDF_ROWS:
    case DELETE_PROJECT_SCHEDULE_OF_VALUES_PDF_ROWS:
      return {
        ...state,
        scheduleOfValuePDFRows: action.payload.scheduleOfValuePDFRows,
      };
    case GET_ALL_PROJECT_COSTCODE_DETAILS:
      return {
        ...state,
        projectCostcodeDetails: action.payload.data,
      };
    case GET_SCHEDULE_OF_VALUE_TEMPLATES:
    case CREATE_SCHEDULE_OF_VALUE_TEMPLATE:
    case UPDATE_SCHEDULE_OF_VALUE_TEMPLATE:
    case DELETE_SCHEDULE_OF_VALUE_TEMPLATE: {
      const {
        payload: {
          templates,
          newTemplate,
        },
      } = action;

      return {
        ...state,
        scheduleOfValueTemplates: templates,
        newTemplate: newTemplate || {},
      };
    }
    case GET_PROJECT_FILE_TEMPLATES:
    case ADD_PROJECT_FILE_TEMPLATE:
    case UPDATE_PROJECT_FILE_TEMPLATE:
    case DELETE_PROJECT_FILE_TEMPLATE: {
      const {
        payload: {
          templates,
        },
      } = action;

      return {
        ...state,
        projectFileTemplates: templates,
      };
    }
    case UPDATE_PROJECT_PROGRESS_FILTERS: {
      const {
        payload: {
          filters: newFilters,
        },
      } = action;

      const {
        projectProgressFilters: existingFilters = {},
      } = state;

      let filters;

      // We will not add the filters if none are passed as they are being cleared
      if (newFilters) {
        filters = {
          ...existingFilters,
          ...newFilters,
        };
      }

      return {
        ...state,
        projectProgressFilters: filters,
      };
    }
    case GET_PROJECT_GROUPS:
    case CREATE_PROJECT_GROUP:
    case UPDATE_PROJECT_GROUP:
    case DELETE_PROJECT_GROUP:
      return {
        ...state,
        projectGroups: action.payload.projectGroups,
      };
    case GET_PROJECT_GROUP_NOTES: {
      const {
        payload: {
          id,
          data: notes = [],
        } = {},
      } = action;
      const { projectGroupsNotes: stateNotes = {} } = state;
      const existingNotes = { ...stateNotes };
      existingNotes[id] = notes;
      existingNotes[id].sort((a, b) => b.timestamp - a.timestamp);
      return {
        ...state,
        projectGroupsNotes: existingNotes,
      };
    }
    case ADD_PROJECT_GROUP_NOTE: {
      const {
        payload = {},
      } = action;
      const { projectGroupId } = payload;
      const { projectGroupsNotes: stateNotes = {} } = state;
      const existingNotes = { ...stateNotes };
      const {
        [projectGroupId]: existingUserNotes = [],
      } = existingNotes;
      existingNotes[projectGroupId] = existingUserNotes.concat([payload]);
      existingNotes[projectGroupId].sort((a, b) => b.timestamp - a.timestamp);
      return {
        ...state,
        projectGroupsNotes: existingNotes,
      };
    }
    case GET_PROJECT_TYPES:
      return {
        ...state,
        projectTypes: action.payload.customTypes,
      };
    case GET_QUICKBOOKS_CLASSES: {
      const {
        payload: {
          data: quickbookClassMap = {},
        } = {},
      } = action;
      return {
        ...state,
        quickbookClassMap,
      };
    }
    case GET_PROJECT_COST_UPDATES: {
      const {
        payload: costUpdates = [],
      } = action;

      return {
        ...state,
        projectCostUpdates: costUpdates,
      };
    }
    case GET_SCHEDULE_OF_VALUE_SECTIONS:
      return {
        ...state,
        scheduleOfValueSections: action.payload.scheduleOfValueSections,
      };
    case CREATE_SCHEDULE_OF_VALUE_SECTION: {
      const {
        payload: {
          scheduleOfValueSection,
        },
      } = action;

      const { scheduleOfValueSections = [] } = state;

      return {
        ...state,
        scheduleOfValueSections: [
          ...scheduleOfValueSections,
          scheduleOfValueSection,
        ],
      };
    }
    case UPDATE_SCHEDULE_OF_VALUE_SECTION: {
      const {
        payload: {
          data,
        },
      } = action;

      const { scheduleOfValueSections = [] } = state;

      return {
        ...state,
        scheduleOfValueSections: scheduleOfValueSections.map((section) => {
          if (section.id === data.id) {
            return {
              ...section,
              ...data,
            };
          }
          return section;
        }),
      };
    }
    case DELETE_SCHEDULE_OF_VALUE_SECTION: {
      const {
        payload: {
          id,
        },
      } = action;

      const { scheduleOfValueSections = [] } = state;

      return {
        ...state,
        scheduleOfValueSections: scheduleOfValueSections.filter((section) => section.id !== id),
      };
    }
    case GET_SUB_CONTRACTS: {
      return {
        ...state,
        subContracts: action.payload.subContracts,
      };
    }
    case GET_PROGRESS_SUBCONTRACT_UPDATES:
    case UPDATE_PROGRESS_SUBCONTRACT:
    case DELETE_PROGRESS_SUBCONTRACT_UPDATE: {
      return {
        ...state,
        subContractUpdates: action.payload.subContractUpdates,
      };
    }
    case UPDATE_PROGRESS_SUBCONTRACT_ROW: {
      const {
        subContractUpdates: {
          [action.payload.key]: rowHistory,
        },
      } = state;

      if (rowHistory) {
        rowHistory.push(action.payload.value);
        return {
          ...state,
          subContractUpdates: {
            ...state.subContractUpdates,
            [action.payload.key]: rowHistory,
          },
        };
      }

      return {
        ...state,
      };
    }
    case GET_PROJECT_CUSTOM_FIELD_TEMPLATE:
    case UPDATE_PROJECT_CUSTOM_FIELD_TEMPLATE: {
      const {
        payload: {
          template = {},
        } = {},
      } = action;
      return {
        ...state,
        customFieldTemplate: template,
      };
    }
    case GET_PROJECT_CUSTOM_DATA: {
      const {
        data: {
          data = [],
          fileMap = {},
        } = {},
      } = action.payload;
      return {
        ...state,
        customData: data,
        customDataFiles: fileMap,
      };
    }
    case GET_PROJECT_NOTES: {
      const {
        payload: {
          id,
          notes = [],
          fileMap = {},
        } = {},
      } = action;
      const { notes: oldNotesMap = {} } = state;
      const newNotesMap = { ...oldNotesMap };
      newNotesMap[id] = notes;
      return {
        ...state,
        notes: newNotesMap,
        notesFileMap: fileMap,
      };
    }
    case ADD_PROJECT_NOTE: {
      const {
        payload = {},
      } = action;
      const { projectId } = payload;
      const { notes: stateNotes = {} } = state;
      const existingNotes = { ...stateNotes };
      const {
        [projectId]: existingProjectNotes = [],
      } = existingNotes;
      existingNotes[projectId] = existingProjectNotes.concat([payload]);
      existingNotes[projectId].sort((a, b) => b.timestamp - a.timestamp);
      return {
        ...state,
        notes: existingNotes,
      };
    }
    case GEOCODE_PROJECT: {
      const {
        id,
        data: {
          lat,
          lng,
        } = {},
      } = action.payload;
      return {
        ...state,
        projects: state.projects.map((project) => {
          if (project.id !== id) return project;
          return {
            ...project,
            latitude: lat,
            longitude: lng,
          };
        }),
      };
    }
    case GET_PROJECT_EQUIPMENT_BUCKET_OVERRIDE_TREE: {
      const {
        payload: {
          data: tree = [],
        } = {},
      } = action;
      return {
        ...state,
        projectEquipmentBucketOverrideTree: tree,
      };
    }
    case GET_PROJECT_EQUIPMENT_TABLE_COLUMNS:
    case UPDATE_PROJECT_EQUIPMENT_TABLE_COLUMNS: {
      const {
        payload: {
          projectTypeId,
          data = [],
        } = {},
      } = action;
      return {
        ...state,
        equipmentTableColumns: {
          ...state.equipmentTableColumns,
          [projectTypeId]: data,
        },
      };
    }
    case GET_PROJECT_LABELS: {
      const { payload: { projectLabels = [] } = {} } = action;
      const {
        itemToLabel: projectToLabel,
        labelToItem: labelToProject,
      } = getLabelsState(projectLabels, 'projectId');
      return {
        ...state,
        projectToLabel,
        labelToProject,
      };
    }
    case GET_MY_PROJECT_TAGS: {
      const {
        payload: {
          myProjectTags = [],
          hasRead,
        } = {},
      } = action;
      if (hasRead) {
        return {
          ...state,
          myReadProjectTags: myProjectTags,
        };
      }
      return {
        ...state,
        myProjectTags,
        projectTagsPerProject: createProjectTagCountMap(myProjectTags),
      };
    }
    case MARK_PROJECT_TAGS_AS_READ: {
      const {
        payload: {
          noteIds = new Set(),
        } = {},
      } = action;
      const { myProjectTags: stateProjectTags = [] } = state;
      const filteredTags = stateProjectTags.filter((tag) => (
        !noteIds.has(tag.projectNoteId)
      ));
      return {
        ...state,
        myProjectTags: filteredTags,
        projectTagsPerProject: createProjectTagCountMap(filteredTags),
      };
    }
    case NEW_PROJECT_TAGS_FROM_SOCKET: {
      const {
        payload: {
          newTags = [],
        } = {},
      } = action;
      const { myProjectTags: stateProjectTags = [] } = state;
      const existingSet = new Set(stateProjectTags.map((tag) => tag.id));
      const fullTags = stateProjectTags.concat(
        newTags.filter((tag) => !existingSet.has(tag.id)),
      );
      return {
        ...state,
        myProjectTags: fullTags,
        projectTagsPerProject: createProjectTagCountMap(fullTags),
      };
    }
    case GET_MY_PROJECT_GROUP_TAGS: {
      const {
        payload: {
          myProjectGroupTags = [],
          hasRead,
        } = {},
      } = action;
      if (hasRead) {
        return {
          ...state,
          myReadProjectGroupTags: myProjectGroupTags,
        };
      }
      return {
        ...state,
        myProjectGroupTags,
        projectGroupTagsPerProjectGroup: createProjectGroupTagCountMap(myProjectGroupTags),
      };
    }
    case MARK_PROJECT_GROUP_TAGS_AS_READ: {
      const {
        payload: {
          noteIds = new Set(),
        } = {},
      } = action;
      const { myProjectGroupTags: stateProjectGroupTags = [] } = state;
      const filteredTags = stateProjectGroupTags.filter((tag) => (
        !noteIds.has(tag.projectGroupNoteId)
      ));
      return {
        ...state,
        myProjectGroupTags: filteredTags,
        projectGroupTagsPerProjectGroup: createProjectGroupTagCountMap(filteredTags),
      };
    }
    case NEW_PROJECT_GROUP_TAGS_FROM_SOCKET: {
      const {
        payload: {
          newTags = [],
        } = {},
      } = action;
      const { myProjectGroupTags: stateProjectGroupTags = [] } = state;
      const existingSet = new Set(stateProjectGroupTags.map((tag) => tag.id));
      const fullTags = stateProjectGroupTags.concat(
        newTags.filter((tag) => !existingSet.has(tag.id)),
      );
      return {
        ...state,
        myProjectGroupTags: fullTags,
        projectGroupTagsPerProjectGroup: createProjectGroupTagCountMap(fullTags),
      };
    }
    case UPDATE_PROJECT_FILTERS: {
      const {
        payload: {
          filters: newFilters,
        },
      } = action;

      let filters = {};

      if (newFilters) {
        filters = {
          ...newFilters,
        };
      }

      return {
        ...state,
        projectFilters: filters,
      };
    }
    case GET_USER_PROJECT_FILTER_VIEWS:
    case CREATE_USER_PROJECT_FILTER_VIEW:
    case DELETE_USER_PROJECT_FILTER_VIEW:
    case FAVOURITE_USER_PROJECT_FILTER_VIEW:
      return {
        ...state,
        projectFilterViews: action.payload.projectFilterViews,
      };
    case UPDATE_USER_PROJECT_FILTER_VIEW: {
      const {
        payload: {
          projectFilterViews,
          filterViewId,
        } = {},
      } = action;
      const filterView = projectFilterViews?.find((view) => view.id === filterViewId);
      return {
        ...state,
        projectFilters: filterView ?? {},
        projectFilterViews,
      };
    }
    case SET_FILTERED_PROJECT_IDS:
      return {
        ...state,
        filteredProjectIds: action.payload.filteredProjectIds,
      };
    case GET_PROJECT_CUSTOM_CATEGORY_ESTIMATES: {
      const {
        payload: {
          projectId,
          data = [],
        } = {},
      } = action;

      return {
        ...state,
        customCategoryEstimates: {
          ...state.customCategoryEstimates,
          [projectId]: data,
        },
      };
    }
    default:
      return state;
  }
}
